var module = angular.module('octopusApp.projects');

module.controller('ProjectOverviewController', function ($scope, $location, busy, $stateParams, $state, projectState, pageTitle, octopusRepository, pollLoop, $q, $uibModal, octopusTagSets) {
    var vm = this;
    var isLoading = vm.isLoading = busy.create();


    vm.showFastboard = false;
    vm.dashboardType = 'project';
    vm.showPrevious = false;
    vm.hasDeploymentSteps = false;
    vm.togglePrevious = togglePrevious;
    vm.openTenantFilterDialog = openTenantFilterDialog;
    vm.searchReleases = searchReleases;

    vm.availableTenants = [];
    vm.tenantPromotions = {};
    vm.dashboardFilter = {showAll: true};
    vm.isFiltered = false;

    vm.clearFilters = false;
    var clearAllFilters = function () {
        vm.dashboardFilter.selectedTags = [];
        vm.dashboardFilter.selectedTenants = [];
        vm.isFiltered = false;
        $location.search("tenants", null);
        $location.search("tags", null);
        refreshActiveComponents();
        return false;
    };

    function extractTenantFilterParams(){
        if ($location.search().tenants){
            var tenantVal = $location.search().tenants;
            if (typeof tenantVal === "string") {
                tenantVal = [tenantVal];
            }
            vm.dashboardFilter.selectedTenants = tenantVal;
            vm.isFiltered = true;
        }
        if ($location.search().tags){
            var tagVal = $location.search().tags;
            if (typeof tagVal === "string") {
                tagVal = [tagVal];
            }
            vm.dashboardFilter.selectedTags = tagVal;
            vm.isFiltered = true;
        }
    }

    function extractReleaseFilterParams() {
        if ($stateParams.release) {
            var foundRelease = _.find(vm.releases, function (item) {
                return item.Version === $stateParams.release;
            });
            if (foundRelease) {
                vm.selectedRelease = foundRelease;
                vm.dashboardFilter.releaseId = foundRelease.Id;
            }
        }
    }

    function extractGroupByParams() {
        if ($stateParams.groupBy) {
            var foundGroupBy = _.find(vm.tagSets, function (item) {
                return item.Name === $stateParams.groupBy;
            });

            if (foundGroupBy) {
                vm.groupBy = foundGroupBy;
            }
        }
    }

    function openTenantFilterDialog() {
        if (vm.clearFilters) {
            clearAllFilters();
            vm.clearFilters = false;
            return;
        }

        $uibModal.open({
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/tenants/advanced_tenant_selector/design_selected_tags_dialog.html',
            controller: 'DesignSelectedTagsController',
            controllerAs: 'vm',
            bindToController: true,
            resolve: {
                selectedValues: function () {
                    return {
                        selectedTenants: vm.dashboardFilter.selectedTenants,
                        selectedTags: vm.dashboardFilter.selectedTags
                    };
                },
                visibleTenantFilter: function () {
                    return function (tenant) {
                        return false;
                    };
                },
                hideTenants: function () {
                    return vm.hideTenants;
                }
            }
        }).result.then(function (result) {
            if (!result) {
                return;
            }
            vm.dashboardFilter.selectedTenants = result.selectedTenants;
            vm.dashboardFilter.selectedTags = result.selectedTags;
            vm.isFiltered = result.selectedTenants.length > 0 || result.selectedTags.length > 0;

            if (vm.dashboardFilter.selectedTenants && vm.dashboardFilter.selectedTenants.length > 0) {
                $location.search('tenants', vm.dashboardFilter.selectedTenants);
            } else {
                $location.search('tenants', undefined);
            }

            if (vm.dashboardFilter.selectedTags && vm.dashboardFilter.selectedTags.length > 0) {
                $location.search('tags', vm.dashboardFilter.selectedTags);
            } else {
                $location.search('tags', undefined);
            }

            refreshActiveComponents();
        });
    }

    function togglePrevious() {
        vm.showPrevious = !vm.showPrevious;
    }

    function getDashboardGroups(tagSet) {
        var groups = [{
            Name: '',
            IsGrouped: true
        }];

        _.each(tagSet.Tags, function (tag) {
            groups.push({
                Name: tagSet.Name + ': ' + tag.Name,
                CanonicalTagName: tag.CanonicalTagName,
                IsGrouped: true
            });
        });
        return groups;
    }

    function getGroupByOptions(tenants) {
        var tagSetsInUse = _.uniq(_.flatten(_.map(tenants, function (tenant) { return tenant.TenantTags; })));
        var groupedTagSets = octopusTagSets.groupByTagSet(tagSetsInUse);
        return _.filter(vm.tagSets, function (tagSet) { return groupedTagSets[tagSet.Name]; });
    }

    function searchReleases(text, isOpen) {
        if(isOpen){
            isLoading.promise(octopusRepository.Projects.getReleases(vm.project, {searchByVersion: text}).then(function (releases) {
                vm.releases = releases.Items;
            }));
        }
    }

    var refreshActiveComponents = function () {
        var project = vm.project;
        if (!vm.showFastboard) {
            return isLoading.promise(octopusRepository.Progression.getProgression(project).then(function (progression) {
                if (vm.progressionSnapshot !== undefined && _.isEqual(vm.progressionSnapshot, progression)) {
                    // Nothing has changed, don't update the view (or this can cause scrollbars to reset their position unnecessarily).
                    return;
                }
                vm.progressionSnapshot = jQuery.extend(true, {}, progression); // deep copy (we can't use vm.progression because it gets tampered with elsewhere, screwing with our equality checks)
                vm.progression = progression;

                if (vm.triggers.Items.length === 0) {
                    vm.unsuccessfulDashboardItemExists = false;
                    return;
                }

                vm.unsuccessfulDashboardItemExists = _.some(vm.progression.Releases, function (release) {
                    return _.some(release.Deployments, function (deployments) {
                         return _.some(deployments, function (deployment) {
                            return isFailedDeploymentForAutoDeployEnvironment(deployment);
                        });
                    });
                });
            }));
        } else {
            return isLoading.promise(octopusRepository.Dashboards.getDashboard(vm.dashboardFilter).then(function (dashboardData) {
                if (vm.dashboardDataSnapshot !== undefined && _.isEqual(vm.dashboardDataSnapshot, dashboardData)) {
                    // Nothing has changed, don't update the view (or this can cause scrollbars to reset their position unnecessarily).
                    return;
                }
                vm.dashboardDataSnapshot = jQuery.extend(true, {}, dashboardData); // deep copy (we can't use vm.dashboardData because it gets tampered with elsewhere, screwing with our equality checks)

                vm.groupByOptions = getGroupByOptions(dashboardData.Tenants);

                _.each(dashboardData.Tenants, function (tenant) {
                    tenant.isMissingVariable = function () {
                        if (!vm.missingVariables) {
                            return null;
                        }
                        return vm.missingVariables.indexOf(tenant.Id) !== -1;
                    };
                });

                if (vm.groupBy) {
                    dashboardData.Groups = getDashboardGroups(vm.groupBy);
                }

                if (vm.dashboardFilter.selectedTags && vm.dashboardFilter.selectedTags.length > 0) {
                    dashboardData.SelectedTags = vm.dashboardFilter.selectedTags;
                }

                if (vm.dashboardFilter.selectedTenants && vm.dashboardFilter.selectedTenants.length > 0) {
                    dashboardData.SelectedTenants = vm.dashboardFilter.selectedTenants;
                }

                vm.unsuccessfulDashboardItemExists = false;
                if (vm.triggers.Items.length > 0) {
                    vm.unsuccessfulDashboardItemExists = _.some(dashboardData.Items, function (dashboardItem) {
                        return isFailedDeploymentForAutoDeployEnvironment(dashboardItem);
                    });
                }

                if (vm.selectedRelease) {
                    return isLoading.promise(octopusRepository.Releases.getDeploymentTemplate(vm.selectedRelease).then(function (template) {
                        var tenantPromotions = {};
                        template.TenantPromotions.forEach(function (tenantPromotion) {
                            tenantPromotion.PromoteTo.forEach(function (environmentPromotion) {
                                var key = environmentPromotion.Id + '__' + tenantPromotion.Id;
                                if (!tenantPromotions[key]) {
                                    tenantPromotions[key] = {
                                        tenantId: tenantPromotion.Id,
                                        environment: environmentPromotion
                                    };
                                }
                            });
                        });
                        dashboardData.TenantPromotions = tenantPromotions;
                        dashboardData.PromoteTo = template.PromoteTo;
                        vm.dashboardData = dashboardData;
                    }));
                } else {
                    vm.dashboardData = dashboardData;
                }
            }));
        }
    };

    function isFailedDeploymentForAutoDeployEnvironment(deployment) {
        if (!isFailedDeployment(deployment)) {
            return false;
        }

        return _.some(vm.triggers.Items, function(trigger) {
            if (trigger.Type !== "DeploymentTarget") {
                return false;
            }

            var triggerEnvironments = trigger.Properties["Octopus.ProjectTriggerCondition.Environments"];

            if (!triggerEnvironments || triggerEnvironments.length === 0) { // any environment
                return true;
            }

            return _.contains(triggerEnvironments.split(','), deployment.EnvironmentId);
        });
    }

    function isFailedDeployment(deployment) {
        return (deployment !== undefined
          && deployment.IsCompleted === true
          && deployment.IsCurrent === true
          && deployment.State !== undefined
          && deployment.State !== 'Success'
          && deployment.State !== 'Queued'
          && deployment.State !== 'Executing');
    }

    function init() {
        var loop = pollLoop.create($scope, function () {
            return refreshActiveComponents();
        });

        extractTenantFilterParams();
        isLoading.promise(projectState.load().then(function (project) {
            vm.project = project;
            vm.dashboardFilter.projectId = project.Id;
            pageTitle(project.Name);

            isLoading.promise(projectState.deploymentProcessAsync.then(function (deploymentProcess) {
                vm.deploymentProcess = deploymentProcess;
                vm.hasDeploymentSteps = vm.deploymentProcess.Steps.length > 0;

                var promises = [];
                promises.push(octopusRepository.Projects.getTriggers(vm.project).then(function (triggers) {
                    vm.triggers = triggers;
                }));

                if (!octopusRepository.Tenants) {
                    isLoading.promises(promises).then(function() {
                        loop.startImmediately();
                    });
                    return;
                }

                promises.push(octopusRepository.Tenants.all({projectId: vm.project.Id}).then(function (tenants) {
                    vm.availableTenants = tenants;
                    vm.showFastboard = tenants.length > 0;
                }));
                promises.push(octopusRepository.Tenants.missingVariables({projectId: vm.project.Id}, false).then(function (missingVariables) {
                    vm.missingVariables = _.pluck(missingVariables, 'TenantId');
                }));
                promises.push(octopusRepository.Projects.getReleases(vm.project).then(function (releases) {
                    vm.releases = _.uniq(_.union(vm.releases, releases.Items), false, function (item, key, a) {
                        return item.Version;
                    });
                }));
                promises.push(octopusTagSets.getAll().then(function (tagSets) {
                    vm.tagSets = tagSets;
                }));

                if ($stateParams.release) {
                    promises.push(octopusRepository.Projects.getReleases(vm.project, {searchByVersion: $stateParams.release}).then(function (releases) {
                        foundRelease = _.find(vm.releases, function (item) {
                            return item.Version === $stateParams.release;
                        });
                        if(!foundRelease){
                            vm.releases = _.uniq(_.union(vm.releases, releases.Items), false, function (item, key, a) {
                                return item.Version;
                            });
                        }
                    }));
                }

                isLoading.promises(promises).then(function() {
                    extractReleaseFilterParams();
                    extractGroupByParams();

                    $scope.$watch('vm.selectedRelease', function (nv, ov) {
                        if (!nv) {
                            vm.dashboardFilter.releaseId = undefined;
                            $state.go($state.current, {release: undefined});
                        } else {
                            vm.dashboardFilter.releaseId = nv.Id;
                            $state.go($state.current, {release: nv.Version});
                        }
                    });

                    $scope.$watch('vm.groupBy', function (nv, ov) {
                        if (!nv) {
                            $state.go($state.current, {groupBy: undefined});
                        } else {
                            $state.go($state.current, {groupBy: nv.Name});
                        }
                    });

                    loop.startImmediately();
                });

            }));
        }));
    }

    init();
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/controllers/project_overview_controller.js
// module id = 3868850243809889
// module chunks = 1